<!--
 * @name: 
 * @Author: zxc
 * @Date: 2021-01-28 14:01:40
 * @LastEditors: zxc
 * @LastEditTime: 2024-01-10 09:49:28
-->
<template>
  <div id="app">
  <!-- <div id="app" @contextmenu.prevent="" style="user-select:none;"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    this.autoChange()
       console.log(navigator.language)
  },
  methods: {
    autoChange() {
     switch (true) {
       case navigator.language.includes('en'):
         this.$store.dispatch('app/setLang', 'en')
         break
       case navigator.language.includes('zh'):
         this.$store.dispatch('app/setLang', 'zh')
         break
      default:
        this.$store.dispatch('app/setLang', 'en')
        break
     }
   }
  },
};
</script>

<style>
/* html {
  height: 100%;
  box-sizing: border-box;
  position: relative;
}
body {
  position:absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0;
  margin: 0;
}
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
a:focus,
a:active {
  outline: none;
}

a,
a:focus,
a:hover {
  cursor: pointer;
  color: inherit;
  text-decoration: none;
}
div {
  padding: 0;
  margin: 0;
} */
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
  /* margin: 0;
  padding: 0; */
  /* width: 100%;
  height: 100%; */
}
.iconfont{
  /* margin-right: 7px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue